import React from 'react'

import { Modal } from 'react-bootstrap'

export default class konfirm extends React.Component {

    render() {
        const { showKonfirm, cancelHandler} = this.props

        return (
            <div class="mb-10">

                <Modal show={showKonfirm}>
                    <Modal.Body>

                        <div>
                            <h5 class="text-center">Jumlah kartu sudah mencapai maksimal</h5>
                        </div>

                        <div class="text-center">
                            <button type="button" class="btn btn-primary" onClick={cancelHandler}>OKE</button>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}